<template>
  <div class="form_layout">
    <div class="form_outer" style="width: 800px;">
      <div class="dialog_form_head">
        提交诉求
      </div>
      <div class="dialog_form">
        <el-form  :model="addData"  :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table">
            <tr>
              <td class="td_bg" width="120px">诉求类型 <span style="color: red;font-weight: bold">*</span></td>
              <td>
                <el-form-item  prop="appealCate">
                <el-select v-model="addData.appealCate" placeholder="请选择" @change="indChange" style="width:100%">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="td_bg">标题 <span style="color: red;font-weight: bold">*</span></td>
              <td>
                <el-form-item  prop="appealTit">
                <el-input v-model="addData.appealTit"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="td_bg">诉求内容 <span style="color: red;font-weight: bold">*</span></td>
              <td>
                <el-form-item  prop="appealCont">
                <el-input type="textarea" :rows="4" v-model="addData.appealCont"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </div>
        </el-form>
        <div class="footer_btn">
          <el-button type="primary" @click="onSubmitSQ('ruleForm')">提 交</el-button>
          <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addappeal',


  data() {
    return {
      addData:{
        appealCont: null,
        appealTit: null,
        appealCate: null,
      },

      options: [{
        value: '1',
        label: '政策申报类'
      }, {
        value: '2',
        label: '人员招聘'
      }, {
        value: '3',
        label: '人才服务类'
      }, {
        value: '4',
        label: '融资需求类'
      }, {
        value: '5',
        label: '项目建设类'
      }, {
        value: '6',
        label: '基础设施建设类'
      }, {
        value: '7',
        label: '安全及环保类'
      }, {
        value: '8',
        label: '厂房土地类需求'
      }, {
        value: '9',
        label: '其他'
      }
      ],
      rules: {
        appealCate: [
          {type: 'string', required: true, message: '请选择诉求类型', trigger: 'change' },
        ],
        appealTit: [
          {type: 'string', required: true, message: '请输入标题', trigger: 'blur' },
          { min: 0, max: 200, message: '标题不能超过200字', trigger: 'blur' }
        ],
        appealCont : [
          {type: 'string', required: true, message: '请输入诉求内容', trigger: 'blur' },
          { min: 0, max: 600, message: '诉求内容不能超过600字', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    indChange() {

    },
    async onSubmitSQ(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitSQ();
        } else {
          setTimeout(()=>{
            var isError = document.getElementsByClassName("is-error");
            console.log(isError)
            var htmlInputElement = isError[0].querySelector('input');
            if(htmlInputElement) htmlInputElement.focus();

            var htmlAreaElement = isError[0].querySelector('textarea');
            if(htmlAreaElement) htmlAreaElement.focus();
          },100);
          // alert('error submit!!');
          return false;
        }
      });
    },
    async submitSQ() {
      let data = {
        sq_cate: this.addData.appealCate,
        sq_title: this.addData.appealTit,
        sq_content: this.addData.appealCont
      }
      let res = await this.$ajax.post(this.bUrl + 'api/portal/questions/add', data);
      this.$emit('emitClose')
      this.$message.success(res.data.msg);

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/user/form/addappeal.vue